'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dialog = require('material-ui/lib/dialog');

var _dialog2 = _interopRequireDefault(_dialog);

var _BinaryCloseButton = require('./../BinaryCloseButton');

var _BinaryCloseButton2 = _interopRequireDefault(_BinaryCloseButton);

var _BinaryButton = require('./../BinaryButton');

var _BinaryButton2 = _interopRequireDefault(_BinaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */


var BinaryDialog = function (_Component) {
  _inherits(BinaryDialog, _Component);

  function BinaryDialog(props) {
    _classCallCheck(this, BinaryDialog);

    var _this = _possibleConstructorReturn(this, (BinaryDialog.__proto__ || Object.getPrototypeOf(BinaryDialog)).call(this, props));

    _this.state = {
      open: false
    };
    _this.styles = require('./BinaryDialog.scss');
    return _this;
  }

  _createClass(BinaryDialog, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          open = _props.open,
          close = _props.close;

      if (open) {
        this.handleOpen();
      }
      if (close) {
        this.handleClose();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.open !== nextProps.open) {
        this.setState({
          open: nextProps.open
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextState, nextProps) {
      this.state.open = nextProps.open;
      if (this.state.open !== nextState.open) {
        return true;
      }
      if (nextProps.onExit) {
        return false;
      }
      if (this.props.disabledButton !== nextProps.disabledButton) {
        return true;
      }
      return false;
    }
  }, {
    key: 'handleOpen',
    value: function handleOpen() {
      this.setState({ open: true });
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      var onExit = this.props.onExit;

      if (onExit) {
        onExit();
      }
      this.setState({ open: false });
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit() {
      var _props2 = this.props,
          onSubmit = _props2.onSubmit,
          buttonsNav = _props2.buttonsNav;

      var nav = typeof buttonsNav !== 'undefined' ? buttonsNav : true;

      if (onSubmit && nav) {
        onSubmit();
      }
      this.handleClose();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          title = _props3.title,
          description = _props3.description,
          buttonsNav = _props3.buttonsNav,
          dialogClassName = _props3.dialogClassName,
          customContentStyle = _props3.customContentStyle;

      var nav = typeof buttonsNav !== 'undefined' ? buttonsNav : true;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _dialog2.default,
          _extends({}, this.props, {
            title: title,
            className: dialogClassName,
            contentStyle: customContentStyle !== undefined ? customContentStyle : '',
            autoScrollBodyContent: true,
            modal: true,
            onRequestClose: this.handleClose.bind(this),
            open: this.state.open
          }),
          !nav && _react2.default.createElement(
            'div',
            { className: this.styles.binary_dialog_close_button },
            _react2.default.createElement(_BinaryCloseButton2.default, { handleClose: this.handleClose.bind(this) })
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: this.styles.binary_dialog_description },
              description
            ),
            nav && _react2.default.createElement(
              'div',
              { className: this.styles.binary_dialog_button },
              _react2.default.createElement(_BinaryButton2.default, {
                key: 'binary_dialog_cancel_button',
                onClick: this.handleClose.bind(this),
                label: 'No',
                className: this.styles.binary_dialog_action_button
              }),
              _react2.default.createElement(_BinaryButton2.default, {
                key: 'binary_dialog_submit_button',
                onClick: this.handleSubmit.bind(this),
                label: 'Yes',
                className: this.styles.binary_dialog_action_button
              })
            )
          )
        )
      );
    }
  }]);

  return BinaryDialog;
}(_react.Component);

BinaryDialog.propTypes = {
  title: _propTypes2.default.string,
  description: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),

  buttonsNav: _propTypes2.default.bool,
  disabledButton: _propTypes2.default.bool,
  open: _propTypes2.default.bool,
  close: _propTypes2.default.bool,
  dialogClassName: _propTypes2.default.string,
  customContentStyle: _propTypes2.default.object,

  onSubmit: _propTypes2.default.func,
  onExit: _propTypes2.default.func
};
BinaryDialog.defaultProps = {
  disabledButton: false,
  title: 'Binary Dialog',
  buttonsNav: false,
  customContentStyle: {}
};
exports.default = BinaryDialog;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryDialog/BinaryDialog.js
// module id = 1062
// module chunks = 1